module.exports = __WEBPACK_EXTERNAL_MODULE_21__;


//////////////////
// WEBPACK FOOTER
// external "angular-ui-router"
// module id = 21
// module chunks = 0